import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ForfeitureReasonForm from '../../../components/forms/ForfeitureReasonForm';
import { useCreateForfeitureReason } from '../../../hooks/useForfeitureReasonApi';
import { useNavigate } from 'react-router-dom';
import { ForfeitureReasonDTO } from '../../../services/apiClient';

const ForfeitureReasonCreate: React.FC = () => {
  const createForfeitureReason = useCreateForfeitureReason();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Forfeiture Reasons', href: '/admin/forfeiturereasons' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ForfeitureReasonDTO) => {
    try {
      await createForfeitureReason.mutateAsync(data);
      navigate('/admin/forfeiturereasons');
    } catch (error) {
      console.error('Error creating ForfeitureReason:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/forfeiturereasons"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ForfeitureReason.Edit'
    >
      <ForfeitureReasonForm
        initialValues={{} as ForfeitureReasonDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/forfeiturereasons')}
      />
    </AdminLayout>
  );
};

export default ForfeitureReasonCreate;
